import React from 'react';
import { Badge } from './ui/badge';

export const StatusBadge = ({ status }) => {
  const statusClass = {
    'Draft': 'status-draft',
    'Open': 'status-open',
    'Approved': 'status-approved',
    'In Progress': 'status-in-progress',
    'Completed': 'status-completed',
    'Closed': 'status-closed',
    'Rejected': 'status-rejected',
    'Cancelled': 'status-cancelled'
  }[status] || 'status-open';

  return (
    <Badge 
      variant="outline" 
      className={`${statusClass} border font-semibold`}
      data-testid={`status-badge-${status?.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {status}
    </Badge>
  );
};

export const PriorityBadge = ({ priority }) => {
  const priorityClass = {
    'High': 'priority-high',
    'Medium': 'priority-medium',
    'Low': 'priority-low'
  }[priority] || 'priority-low';

  return (
    <Badge 
      variant="outline" 
      className={`${priorityClass} border font-semibold`}
      data-testid={`priority-badge-${priority?.toLowerCase()}`}
    >
      {priority}
    </Badge>
  );
};
